import { type } from "@testing-library/user-event/dist/type"

export const contactFormAction = (data)=>{
    return {
        type:"submit_btn",
        data
    }
}